{
  "__schema": {
    "types": [
      {
        "kind": "INTERFACE",
        "name": "ActivityDuration",
        "possibleTypes": [
          {
            "name": "OrgActivityTimeline"
          },
          {
            "name": "UserActivityDetails"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "AlertCondition",
        "possibleTypes": [
          {
            "name": "FinishedRunCondition"
          },
          {
            "name": "ScriptableRunCondition"
          },
          {
            "name": "StoppedRunCondition"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "AlertSubscription",
        "possibleTypes": [
          {
            "name": "EmailSubscription"
          },
          {
            "name": "SlackChannelSubscription"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "ArtifactAction",
        "possibleTypes": [
          {
            "name": "DeleteArtifactAction"
          },
          {
            "name": "MoveArtifactAliasAction"
          },
          {
            "name": "UpdateArtifactAction"
          },
          {
            "name": "UseArtifactAction"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "ArtifactCollection",
        "possibleTypes": [
          {
            "name": "ArtifactPortfolio"
          },
          {
            "name": "ArtifactSequence"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "ArtifactConnectionType",
        "possibleTypes": [
          {
            "name": "ArtifactConnection"
          },
          {
            "name": "InputArtifactConnection"
          },
          {
            "name": "VersionedArtifactConnection"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "ArtifactEdgeType",
        "possibleTypes": [
          {
            "name": "ArtifactEdge"
          },
          {
            "name": "InputArtifactEdge"
          },
          {
            "name": "VersionedArtifactEdge"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "BucketType",
        "possibleTypes": [
          {
            "name": "Run"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "ClientIDMappingEntry",
        "possibleTypes": [
          {
            "name": "Artifact"
          },
          {
            "name": "ArtifactSequence"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "Error",
        "possibleTypes": [
          {
            "name": "BucketStoreConnectionError"
          },
          {
            "name": "RunQueueItemInfoDetails"
          },
          {
            "name": "TriggerExecutionError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "Initiator",
        "possibleTypes": [
          {
            "name": "Run"
          },
          {
            "name": "User"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "Integration",
        "possibleTypes": [
          {
            "name": "GenericWebhookIntegration"
          },
          {
            "name": "GitHubOAuthIntegration"
          },
          {
            "name": "SlackIntegration"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "MaybeGroupedRunConnection",
        "possibleTypes": [
          {
            "name": "GroupedRunConnection"
          },
          {
            "name": "RunConnection"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "Node",
        "possibleTypes": [
          {
            "name": "ActiveExperiment"
          },
          {
            "name": "Agent"
          },
          {
            "name": "Entity"
          },
          {
            "name": "EntityUser"
          },
          {
            "name": "ExpansionPack"
          },
          {
            "name": "Experiment"
          },
          {
            "name": "File"
          },
          {
            "name": "GroupedRun"
          },
          {
            "name": "LocalLicense"
          },
          {
            "name": "Organization"
          },
          {
            "name": "Project"
          },
          {
            "name": "Repo"
          },
          {
            "name": "Run"
          },
          {
            "name": "Sweep"
          },
          {
            "name": "User"
          },
          {
            "name": "View"
          },
          {
            "name": "WorkspaceTemplate"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "SandboxLauncher",
        "possibleTypes": [
          {
            "name": "RegistryModelDeployment"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "StorageTreeNode",
        "possibleTypes": [
          {
            "name": "ArtifactSequenceStorageNode"
          },
          {
            "name": "ArtifactStorageNode"
          },
          {
            "name": "ArtifactTypeStorageNode"
          },
          {
            "name": "EntityStorageNode"
          },
          {
            "name": "FileStorageNode"
          },
          {
            "name": "ProjectStorageNode"
          },
          {
            "name": "RunStorageNode"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "TagGroup",
        "possibleTypes": [
          {
            "name": "Entity"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "TaggedObject",
        "possibleTypes": [
          {
            "name": "Artifact"
          },
          {
            "name": "ArtifactPortfolio"
          },
          {
            "name": "ArtifactSequence"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "TriggerActionDetails",
        "possibleTypes": [
          {
            "name": "ARIAActionArgs"
          },
          {
            "name": "GenericWebhookActionArgs"
          },
          {
            "name": "NoOpActionArgs"
          },
          {
            "name": "PushNotificationActionArgs"
          },
          {
            "name": "QueueJobActionArgs"
          },
          {
            "name": "SlackNotificationActionArgs"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "TriggerEventDetails",
        "possibleTypes": [
          {
            "name": "ArtifactAliasEventDetails"
          },
          {
            "name": "ArtifactEventDetails"
          },
          {
            "name": "ArtifactTagEventDetails"
          },
          {
            "name": "CollectionTagEventDetails"
          },
          {
            "name": "RunMetricEventDetails"
          },
          {
            "name": "RunStateEventDetails"
          },
          {
            "name": "SandboxStateEventDetails"
          },
          {
            "name": "WeaveMetricThresholdEventDetails"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "TriggerResultDetails",
        "possibleTypes": [
          {
            "name": "DefaultTriggerResultDetails"
          },
          {
            "name": "HttpTriggerResultDetails"
          },
          {
            "name": "PushNotificationTriggerResultDetails"
          },
          {
            "name": "QueuedJobTriggerResultDetails"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "TriggerScope",
        "possibleTypes": [
          {
            "name": "ArtifactPortfolio"
          },
          {
            "name": "ArtifactSequence"
          },
          {
            "name": "Entity"
          },
          {
            "name": "Project"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "TriggeredAction",
        "possibleTypes": [
          {
            "name": "ARIATriggeredAction"
          },
          {
            "name": "GenericWebhookTriggeredAction"
          },
          {
            "name": "NoOpTriggeredAction"
          },
          {
            "name": "NotificationTriggeredAction"
          },
          {
            "name": "PushNotificationTriggeredAction"
          },
          {
            "name": "QueueJobTriggeredAction"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "TriggeringCondition",
        "possibleTypes": [
          {
            "name": "FilterEventTriggeringCondition"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "UsageAggregationInterface",
        "possibleTypes": [
          {
            "name": "InferenceCostUsageAggregation"
          },
          {
            "name": "TrainingCostUsageAggregation"
          },
          {
            "name": "UsageAggregation"
          }
        ]
      }
    ]
  }
}